<template>
  <div>
    <div class="cert-header d-flex py-5">
      <div class="col-9 mx-auto">
        <div class="my-auto ml-auto cert-search w-100">
          <div class="d-flex flex-row">
            <div class="w-100 d-flex flex-column">
              <div ref="search-container" class="cert-search-box w-100">
                <input ref="search" class="w-100" type="text" placeholder="Search"
                       @keyup.enter="search($refs['search'].value)"/>
                <div class="cert-search-btn" @click="search($refs['search'].value)">
                  <micon icon="search" class="my-auto"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="results!=null"
         class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
      <div v-if="results.length!==0">
        <div v-for="(item,index) in results" :key="index">
          <cert-search-result :id="item.id" :title="item.title" :content="item.body" :date="item.date"
                              :image="item.imageLink" :type="item.type"/>
        </div>
      </div>
      <div v-if="results.length===0">
        No Results
      </div>
    </div>
  </div>

</template>

<script>
import api from "@/api";
import CertSearchResult from "./components/CertSearchResult";

export default {
  name: "Search",
  components: {
    CertSearchResult
  },
  data() {
    return {
      results: null,
    };
  },
  methods: {
    search(terms) {
      terms = terms.trim();
      if (terms === '')
        return;
      api.get(`${process.env.VUE_APP_BASE_URL}filter?search=${terms}`)
          .then((response) => {
            this.results = response.data;
          })
          .catch((error) => {
            error;
          });
    },
  },
  mounted() {
    this.$anim.fadeInBottomOpaque(this.$refs["search-container"], 50);

    let terms = this.$route.params.terms;
    if (terms == null)
      return;
    this.$refs["search"].value = terms;
    this.search(terms)
  }
}
</script>